import { useState } from "react"
import { cn } from "@/lib/cn"

// Standard avatar with initials fallback. Use this everywhere an
// AppUser / User / CompanyUser / Agent is rendered with a profile image.
//
// Falls back to a gradient circle with the first letter of the name when
// no URL is provided OR the URL fails to load. Matches the gradient used
// by the existing RowAvatar in Settings/Team.tsx.
type Props = {
  name: string
  url?: string | null
  size?: number
  className?: string
}

export function Avatar({ name, url, size = 32, className }: Props) {
  const [imgFailed, setImgFailed] = useState(false)
  const initial = (name.trim()[0] ?? "?").toUpperCase()

  if (url && !imgFailed) {
    return (
      <img
        src={url}
        alt={name}
        onError={() => setImgFailed(true)}
        style={{ width: size, height: size }}
        className={cn("shrink-0 rounded-full border border-border object-cover", className)}
      />
    )
  }
  return (
    <div
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-brand-red to-brand-redDeep font-semibold text-white shadow-redGlow",
        className,
      )}
    >
      {initial}
    </div>
  )
}
